<template>
  <div>
    <div class="toolbar">
      <el-input v-model="keyword" clearable placeholder="供应商名称" style="width:220px" @keyup.enter.native="load" />
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增供应商</el-button>
    </div>
    <el-table :data="pageList" border v-loading="loading">
      <el-table-column prop="name" label="供应商" min-width="160" />
      <el-table-column prop="contactName" label="联系人" width="110" />
      <el-table-column prop="contactPhone" label="电话" width="130" />
      <el-table-column prop="address" label="地址" min-width="160" show-overflow-tooltip />
      <el-table-column prop="loginUsername" label="登录账号" width="140" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.loginUsername || '-' }}</template>
      </el-table-column>
      <el-table-column prop="enabled" label="状态" width="90">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="row.enabled===1?'success':'info'">{{ row.enabled===1?'启用':'停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160" fixed="right">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openEdit(row)">编辑</el-button>
          <el-button type="text" @click="openAccount(row)">开通账号</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-dialog :title="form.id?'编辑供应商':'新增供应商'" :visible.sync="visible" width="520px">
      <el-form :model="form" label-width="90px">
        <el-form-item label="名称" required><el-input v-model="form.name" /></el-form-item>
        <el-form-item label="联系人" required><el-input v-model="form.contactName" /></el-form-item>
        <el-form-item label="电话" required><el-input v-model="form.contactPhone" /></el-form-item>
        <el-form-item label="地址"><el-input v-model="form.address" /></el-form-item>
        <el-form-item label="状态"><el-switch v-model="form.enabled" :active-value="1" :inactive-value="0" /></el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="visible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="accountHasAccount?'供应商账号':'开通供应商账号'" :visible.sync="accountVisible" width="460px">
      <p style="margin:0 0 12px;color:#64748b;font-size:13px">供应商：{{ accountSupplierName }}</p>
      <p v-if="accountUsageTip" class="quota-tip">{{ accountUsageTip }}</p>
      <el-form :model="account" label-width="90px">
        <el-form-item label="登录账号" required>
          <el-input v-model="account.username" placeholder="手机号或用户名" />
        </el-form-item>
        <el-form-item :label="accountHasAccount ? '密码' : '密码'" :required="!accountHasAccount">
          <el-input
            v-model="account.password"
            type="password"
            show-password
            :placeholder="accountHasAccount?'不修改请留空；填写须含字母和数字':'至少6位，含字母和数字'"
          />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="accountVisible=false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="saveAccount">
          {{ accountHasAccount ? '保存' : '开通' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listSuppliers, saveSupplier, deleteSupplier,
  createSupplierAccount, getSupplierAccount
} from '../../api/supply'
import { fetchMe } from '../../api/auth'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'
import { passwordError } from '../../utils/password'
import { accountUsageText, planNameOf } from '../../utils/plan'

export default {
  name: 'Supplier',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    return {
      keyword: '', list: [], loading: false, saving: false,
      visible: false, form: {},
      accountVisible: false,
      accountSupplierId: null,
      accountSupplierName: '',
      accountHasAccount: false,
      account: { username: '', password: '' }
    }
  },
  computed: {
    accountUsageTip() {
      const user = this.$store.state.user || {}
      const usage = accountUsageText(user)
      if (!usage) return ''
      const plan = planNameOf(user)
      return plan ? `当前套餐：${plan}（${usage}）` : `当前${usage}`
    }
  },
  created() { this.load() },
  methods: {
    async refreshQuota() {
      try {
        const res = await fetchMe()
        this.$store.commit('patchUser', res.data || {})
      } catch (e) { /* ignore */ }
    },
    async load() {
      this.loading = true
      try {
        const res = await listSuppliers({ keyword: this.keyword })
        this.list = res.data || []
        this.page = 1
      } finally { this.loading = false }
    },
    openEdit(row) {
      this.form = row
        ? {
          id: row.id,
          name: row.name,
          contactName: row.contactName,
          contactPhone: row.contactPhone,
          address: row.address,
          enabled: row.enabled,
          remark: row.remark
        }
        : { id: null, name: '', contactName: '', contactPhone: '', address: '', enabled: 1, remark: '' }
      this.visible = true
    },
    async save() {
      if (!this.form.name) return this.$message.warning('请填写名称')
      if (!(this.form.contactName || '').trim()) return this.$message.warning('请填写联系人')
      if (!(this.form.contactPhone || '').trim()) return this.$message.warning('请填写电话')
      this.saving = true
      try {
        await saveSupplier(this.form)
        this.$message.success('已保存')
        this.visible = false
        this.load()
      } finally { this.saving = false }
    },
    async openAccount(row) {
      this.accountSupplierId = row.id
      this.accountSupplierName = row.name
      this.account = { username: '', password: '' }
      this.accountHasAccount = false
      this.accountVisible = true
      await this.refreshQuota()
      try {
        const res = await getSupplierAccount(row.id)
        const data = res.data || {}
        this.accountHasAccount = !!data.hasAccount
        this.account = {
          username: data.username || '',
          password: ''
        }
      } catch (e) {
        this.account = {
          username: row.loginUsername || row.contactPhone || '',
          password: ''
        }
        this.accountHasAccount = !!row.hasAccount
      }
    },
    async saveAccount() {
      if (!this.account.username) return this.$message.warning('请填写登录账号')
      if (!this.accountHasAccount && !this.account.password) {
        return this.$message.warning('请设置密码')
      }
      const pwdErr = passwordError(this.account.password, !this.accountHasAccount)
      if (pwdErr) return this.$message.warning(pwdErr)
      this.saving = true
      try {
        const payload = {
          username: this.account.username
        }
        if (this.account.password) payload.password = this.account.password
        await createSupplierAccount(this.accountSupplierId, payload)
        this.$message.success(this.accountHasAccount ? '账号已保存' : '账号已开通')
        this.accountVisible = false
        await this.refreshQuota()
        this.load()
      } finally { this.saving = false }
    },
    onDelete(row) {
      this.$confirm(`确认删除「${row.name}」？`, '提示', { type: 'warning' })
        .then(async () => { await deleteSupplier(row.id); this.$message.success('已删除'); this.load() })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.toolbar { display:flex; gap:8px; margin-bottom:12px; flex-wrap:wrap; }
.quota-tip {
  margin: 0 0 12px;
  padding: 8px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #475569;
  font-size: 13px;
  line-height: 1.5;
}
</style>
